import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    staticStyle: {
      "margin-left": "20%"
    },
    attrs: {
      model: _vm.form,
      "label-position": "left",
      "label-width": "150px"
    }
  }, [!_vm.isEditPage ? _c("el-form-item", {
    attrs: {
      label: "是否使用模板"
    }
  }, [_vm._v(" 不使用 "), _c("el-switch", {
    attrs: {
      "active-value": 1,
      "inactive-value": 0
    },
    model: {
      value: _vm.isTemp,
      callback: function callback($$v) {
        _vm.isTemp = $$v;
      },
      expression: "isTemp"
    }
  }), _vm._v("使用 ")], 1) : _vm._e(), _vm.isTemp == 1 && !_vm.isEditPage ? _c("el-form-item", {
    attrs: {
      label: "选择模板"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      placeholder: "无模板"
    },
    model: {
      value: _vm.temp_value,
      callback: function callback($$v) {
        _vm.temp_value = $$v;
      },
      expression: "temp_value"
    }
  }, _vm._l(_vm.tempOptions, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: "【" + item.id + "】" + item.temp_name,
        value: item.id
      }
    });
  }), 1)], 1) : _vm._e(), _vm.isEditPage || !_vm.isEditPage && _vm.isTemp == 0 || !_vm.isEditPage && _vm.isTemp == 1 && _vm.temp_value ? _c("div", [_c("el-form-item", {
    attrs: {
      label: "服务器列表",
      required: ""
    }
  }, [_c("server-list", {
    attrs: {
      readCacheType: 1,
      multiple: false,
      type: 1
    },
    model: {
      value: _vm.form.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "server_id", $$v);
      },
      expression: "form.server_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "选择玩家类型",
      required: ""
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      placeholder: "选择玩家ID或昵称"
    },
    on: {
      change: _vm.selPlayerChanged
    },
    model: {
      value: _vm.form.role_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "role_type", $$v);
      },
      expression: "form.role_type"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1), _vm.form.role_type == 1 ? _c("el-form-item", {
    attrs: {
      label: "玩家ID",
      required: ""
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 3,
        maxRows: 5
      },
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.playerIDString,
      callback: function callback($$v) {
        _vm.playerIDString = typeof $$v === "string" ? $$v.trim() : $$v;
      },
      expression: "playerIDString"
    }
  }), _c("p", {
    staticStyle: {
      color: "#FF5050",
      "font-size": "12px"
    }
  }, [_vm._v("备注：玩家ID之间,请用（英文逗号）隔开")])], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "已读邮件后保留时间",
      required: ""
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "300px"
    },
    attrs: {
      type: "datetime",
      placeholder: "选择日期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.form.expire,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "expire", $$v);
      },
      expression: "form.expire"
    }
  })], 1), _c("div", [_c("el-divider", {
    attrs: {
      "content-position": "left"
    }
  })], 1), _c("fill-email-msg", {
    attrs: {
      form: _vm.form
    }
  })], 1) : _vm._e()], 1), _c("div", {
    staticClass: "botStyle"
  }, [_vm.isTemp == 0 && !_vm.isEditPage ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.tempBtn();
      }
    }
  }, [_vm._v("保存作为模板")]) : _vm._e(), _vm.isTemp == 1 && !_vm.isEditPage && _vm.temp_value ? _c("el-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function click($event) {
        return _vm.deleteTempBtn();
      }
    }
  }, [_vm._v("删除模板")]) : _vm._e(), _vm.isTemp == 1 && !_vm.isEditPage && _vm.temp_value ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.tempBtn();
      }
    }
  }, [_vm._v("保存为新的模板")]) : _vm._e(), _vm.isTemp == 1 && !_vm.isEditPage && _vm.temp_value ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.tempEditBtn();
      }
    }
  }, [_vm._v("覆盖当前模板")]) : _vm._e(), _vm.isTemp == 0 && !_vm.isEditPage && _vm.temp_value ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.tempBtn();
      }
    }
  }, [_vm._v("保存为新的模板")]) : _vm._e(), _vm.isEditPage || !_vm.isEditPage && _vm.isTemp == 0 || !_vm.isEditPage && _vm.isTemp == 1 && _vm.temp_value ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.checkAllEmail();
      }
    }
  }, [_vm._v("提交审核")]) : _vm._e()], 1), _vm.tempDialog ? _c("el-dialog", {
    attrs: {
      title: "填写模板信息",
      visible: _vm.tempDialog,
      center: "",
      "append-to-body": ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.tempDialog = $event;
      }
    }
  }, [_c("temp-comp", {
    staticStyle: {
      height: "200px",
      "overflow-y": "auto"
    },
    attrs: {
      form: _vm.form,
      temp_id: _vm.tempDialogId,
      old_temp_name: _vm.tempDialogName,
      temp_type: 1
    },
    on: {
      backTemp: _vm.backTemp
    }
  })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };